/* Version 2026-10-08 95422d3 */
/* English: plural to singular.

   Taken from github.com/low/dutch-inflection-rules and ICanBoogie/Inflector
   (BSD), through the table in owcjournal3inflect.php on the live site, and
   converted rather than retyped. The theme loads this file only for a visitor
   browsing in english; English rides along always, because the
   catalogue is written in English and people type English words in every
   language.

   Nothing here decides anything on its own: phones-search-terms.js offers every
   stem to the shop's own word list and uses only what the shop actually says. */

(window.phonesSearch = window.phonesSearch || {}).en = {
  /* words that have no plural, and so must never be shortened */
  keep: ["advice","aircraft","art","baggage","butter","clothing","coal","cotton","deer","equipment","experience","feedback","fish","flour","food","furniture","gas","homework","impatience","information","jeans","knowledge","leather","love","luggage","management","money","moose","music","news","oil","patience","police","polish","progress","research","rice","salmon","sand","series","sheep","silk","sms","soap","spam","species","staff","sugar","swine","talent","toothpaste","traffic","travel","vinegar","weather","wood","wool","work"],
  singular: [
    [/(quiz)zes$/i, "$1"],
    [/(matr)ices$/i, "$1ix"],
    [/(vert|ind)ices$/i, "$1ex"],
    [/^(ox)en$/i, "$1"],
    [/(alias)es$/i, "$1"],
    [/(octop|vir)i$/i, "$1us"],
    [/(cris|ax|test)es$/i, "$1is"],
    [/(shoe)s$/i, "$1"],
    [/(o)es$/i, "$1"],
    [/(bus)es$/i, "$1"],
    [/([m|l])ice$/i, "$1ouse"],
    [/(x|ch|ss|sh)es$/i, "$1"],
    [/(m)ovies$/i, "$1ovie"],
    [/(s)eries$/i, "$1eries"],
    [/([^aeiouy]|qu)ies$/i, "$1y"],
    [/([lr])ves$/i, "$1f"],
    [/(tive)s$/i, "$1"],
    [/(hive)s$/i, "$1"],
    [/(li|wi|kni)ves$/i, "$1fe"],
    [/(shea|loa|lea|thie)ves$/i, "$1f"],
    [/(^analy)ses$/i, "$1sis"],
    [/((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$/i, "$1$2sis"],
    [/([ti])a$/i, "$1um"],
    [/(n)ews$/i, "$1ews"],
    [/(h|bl)ouses$/i, "$1ouse"],
    [/(corpse)s$/i, "$1"],
    [/(us)es$/i, "$1"],
    [/(?<!ss|us|is|ous|ch|sh)s$/i, ""],
  ],
};
